<template>
  <div>
    <div class="mod-extra-segment-pc">
      <div
        class="mod-segment-wrapper"
        v-for="(item ,index) in itinerarys"
        :key="index"
        @click="selectSegment(index)"
      >
        <div :class="['segment' ,'clearfix', current.segmentIndex === index ? 'left-sel' : '']">
          <span>{{item.depName}}</span>
          <img
            :src="flightImage(current.segmentIndex === index)"
            alt=""
          >
          <span>{{item.arrName}}</span>
        </div>
        <div class="segment-info clearfix">
          <table>
            <tr>
              <td class="w-86 f-b t-r">航班号：</td>
              <td class="t-l" colspan="3">{{item.flightNo}}</td>
            </tr>
            <tr>
              <td class="w-60 f-b t-r">起飞时间：</td>
              <td class="t-l" colspan="3">{{moment(item.depTime).format('YYYY-MM-DD HH:mm')}}</td>
            </tr>
            <tr>
              <td class="w-86 f-b t-r">客票状态：</td>
              <td class="t-l" colspan="3">{{getTicketStatusCn(item.status)}}</td>
            </tr>
            <tr>
              <td class="w-60 f-b t-r">票号：</td>
              <td class="t-l" colspan="3">{{item.ticketNo}}</td>
            </tr>
            <tr v-if="!item.ifInternational && item.benefits">
              <td class="w-86 f-b f-red t-r">免费托运行李：</td>
              <td class="w-50 f-red t-l">{{ getBenefit(item, 'luggage') }}</td>
              <td class="w-60 f-b f-red t-r">免费餐食：</td>
              <td class="f-red t-l">{{ getBenefit(item, 'meal') }}</td>
            </tr>
            <!-- 通用版接口暂不支持 -->
            <!-- <tr>
              <td class="w-86 f-b f-red t-r">付费行李：</td>
              <td class="w-50 f-red t-l">{{item.bought&&item.bought.LUGGAGE?item.bought.LUGGAGE:'0KG'}}</td>
              <td class="w-60 f-b f-red t-r">付费餐食：</td>
              <td class="f-red t-l">{{item.bought&&item.bought.MEALS?item.bought.MEALS:'无'}}</td>
            </tr>
            <tr>
              <td class="w-86 f-b f-red t-r">行程单：</td>
              <td class="w-50 f-red t-l">{{item.bought&&item.bought.ITINERARY?'有':'无'}}</td>
              <td class="w-60 f-b  f-red t-r">贵宾厅：</td>
              <td class="f-red t-l">{{item.bought&&item.bought.VIPHALL?item.bought.VIPHALL:'无'}}</td>
            </tr>
            <tr>
              <td class="w-60 f-b f-red t-r">保险：</td>
              <td class="f-red w-50 t-l" >{{item.bought&&item.bought.INSURANCE?item.bought.INSURANCE:'无'}}</td>
            </tr> -->
          </table>
        </div>
      </div>
    </div>
    <div class="mod-extra-segment-phone">
      <div class="segment-wrapper">
        <div
          :class="['segment', current.segmentIndex === index ? 'on' : '']"
          v-for="(item ,index) in itinerarys"
          :key="index"
          @click="selectSegment(index)"
        >
          <span>{{item.depName}}-{{item.arrName}}</span>
          <span>起飞时间:{{moment(item.depTime).format('YYYY-MM-DD HH:mm')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/components/l8-icon'

const TicketStatusCn = {
  'OPEN FOR USE': '可使用', // 客票未使用,有效
  'VOID': '已作废', // 已作废
  'REFUNDED': '已退票', // 已退票
  'CHECKED IN': '已经办理值机', // 已经办理值机
  'LIFT/BOARED': '已经离港', // 客票已使用（可修改）
  'USED/FLOWN': '客票已使用', // 客票已使用（不可修改）
  'SUSPENDED': '禁止使用', // 系统处理，客票禁止使用
  'PRINT/EXCH': '电子客票已换开为纸票', // 电子客票已换开为纸票
  'EXCHANGE': '换开ET/手工换开', // 换开ET/手工换开
  'FIM/EXCHANGE': '使用中断舱单签转外航', // 使用中断舱单签转外航
  'LIFT/BOARDED': '已登机',
  'UNKNOWN': '未知状态'
}

export default {
  props: {
    itinerarys: {
      type: Array
    },
    current: {
      type: Object,
      default: function () {
        return {
          segmentIndex: 0,
          passengerIndex: 0
        }
      }
    }
  },
  methods: {
    selectSegment (index) {
      this.$emit('select', index)
    },
    flightImage (on) {
      if (on) {
        return require('../img/extra-flight-red.png')
      } else {
        return require('../img/extra-flight.png')
      }
    },
    getTicketStatusCn (status) {
      return TicketStatusCn[status] || '--'
    },
    getBenefit (value, name) {
      let text = '-'
      if (name === 'luggage') {
        text = value?.benefits?.luggage || '0'
      } else if (name === 'meal') {
        text = value?.benefits?.meal || '无'
      }
      return text
    }
  }
}
</script>

<style lang="less">
.mod-extra-book {
  background: #f5f5f5;
}

.mod-segment-wrapper {
  width: 328px;
  text-align: center;
  color: #666;
  vertical-align: middle;
  margin-bottom: 20px;
  border-radius: 16px;
  background: #fff;
  border: none;

  &:hover, &.actived {
    transform: scale(1.05,1.05);
    transition: 0.8s ease-in-out;
  }

  .segment {
    font-size: 18px;
    font-weight: bold;
    line-height: 72px;
    border-bottom: solid 1px #eee;

    img {
      width: 37px;
      height: 18px;
      margin: 0 25px;
    }
  }

  .segment-info {
    font-size: 12px;
    line-height: 20px;
    padding: 10px;
    cursor: pointer;
    & > div {
      text-align: left;
      line-height: 1.8;
    }

    p {
      margin-bottom: 0;
    }
  }

  .passenger {
    padding: 0px 20px;
    font-size: 14px;
    height: 58px;
    box-sizing: border-box;
    line-height: 58px;
    cursor: pointer;
    border-top: 1px solid #eee;

    & > span {
      float: left;
    }

    .right-status {
      float: right;
      color: @primary-color;
      line-height: 58px;

      .icon {
        margin-left: 10px;
        vertical-align: middle;
      }
    }
  }

  .left-sel {
    color: #fff;
    background: @primary-color;
    position: relative;
    border-radius: 16px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    &::after {
      content: "";
      width: 0;
      height: 0;
      border-top: 29px solid transparent;
      border-bottom: 29px solid transparent;
      border-left: 8px solid @primary-color;
      position: absolute;
      right: -8px;
      display: none;
    }

    .right-status {
      color: #fff;
    }
  }

  .f-red {
    color: @primary-color;
    max-width: 114px;
  }
  .w-86 {
    width: 86px;
  }
  .w-50 {
    width: 50px;
  }
  .w-60 {
    width: 62px;
  }
  .f-b {
    font-weight: bold;
  }
  .t-l {
    text-align: left;
  }
  .t-r {
    text-align: right;
  }
}
.mod-extra-segment-phone {
  display: none;
}
@media only screen and (max-width: 768px) {
  .mod-extra-segment-pc {
    display: none;
  }
  .mod-extra-segment-phone {
    display: block;
    .segment-wrapper {
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 68px;
      font-size: 14px;
      border-bottom: solid 1px #afafaf;
      border-left: solid 1px #afafaf;

      .segment {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: solid #afafaf;
        border-width: 1px 1px 0 0;
        width: 50%;
        background: #f5f5f5;
      }
      .on {
        background: @primary-color;
        color: #fff;
      }
    }
  }
}
</style>
